/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const CHECK = 'CHECK';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const CHECK_DESKDAF = 'CHECK_DESKDAF';
export const LOGIN_DESKDAF = 'LOGIN_DESKDAF';
export const LOGOUT_DESKDAF = 'LOGOUT_DESKDAF';
export const CHECK_EDOCSIGN = 'CHECK_EDOCSIGN';
export const LOGIN_EDOCSIGN = 'LOGIN_EDOCSIGN';
export const LOGOUT_EDOCSIGN = 'LOGOUT_EDOCSIGN';

export default {
  CHECK,
  LOGIN,
  LOGOUT,
  CHECK_DESKDAF,
  LOGIN_DESKDAF,
  LOGOUT_DESKDAF,
  CHECK_EDOCSIGN,
  LOGIN_EDOCSIGN,
  LOGOUT_EDOCSIGN,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutation-types.js